module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Card', {
    staticClass: "homepagecard",
    attrs: {
      "bordered": false,
      "padding": _vm.padding,
      "shadow": true
    }
  }, [_c('p', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.extra) ? _c('a', {
    staticClass: "hompage-card-extra",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.$emit('extraClick')
      }
    },
    slot: "extra"
  }, [_vm._v(_vm._s(_vm.extra))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0b021e4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Card.vue
// module id = 735
// module chunks = 0